<template>
  <v-card>
    <v-card-text>
      <Project />
    </v-card-text>
  </v-card>
</template>

<script>
import Project from "@/components/Project";

export default {
  components: {
    Project
  }
}
</script>

<style>

</style>